import '@rainbow-me/rainbowkit/styles.css'

import { connectorsForWallets, getDefaultWallets } from '@rainbow-me/rainbowkit'
import { Chain, configureChains, createConfig } from 'wagmi'
import { alchemyProvider } from 'wagmi/providers/alchemy'
import { publicProvider } from 'wagmi/providers/public'
import {
  braveWallet,
  coinbaseWallet,
  injectedWallet,
  metaMaskWallet,
  okxWallet,
  rabbyWallet,
  rainbowWallet,
  walletConnectWallet,
} from "@rainbow-me/rainbowkit/wallets";

const BERA_TEST: Chain = {
  id: 80084,
  network: 'BERA',
  name: 'BERA',
  nativeCurrency: {
    name: 'BERA ',
    symbol: 'BERA',
    decimals: 18,
  },
  rpcUrls: {
    default: {
      http: ['https://bartio.rpc.berachain.com/'],
    },
    public: {
      http: ['https://bartio.rpc.berachain.com/'],
    },
  },
  testnet: true,
  // hasIcon: true,
  // iconUrl: 'https://raw.githubusercontent.com/metaverseblock/token-icon/main/48899/ZIRCUIT.png',
}


const { chains, publicClient } = configureChains(
  [BERA_TEST],
  [alchemyProvider({ apiKey: 'bBUosx2q8Pm3dJKBkoxKxPoW5JwPNFDy' }), publicProvider()]
  // [infuraProvider({ apiKey: 'f7d803169aa248f28a510d0d1889951c' })]
)
const walletConnectProjectId = 'd9e02d8e4a4bb8fe574b63430fa1cf34'
const needsInjectedWalletFallback =
  typeof window !== "undefined" &&
  window.ethereum &&
  !window.ethereum.isMetaMask &&
  !window.ethereum.isCoinbaseWallet;



const connectors = connectorsForWallets([{
  groupName: "ROGUEX",
  wallets: [
    metaMaskWallet({
      projectId: walletConnectProjectId,
      chains,
      shimDisconnect: true,
    }),
    braveWallet({ chains, shimDisconnect: true }),
    rainbowWallet({ projectId: walletConnectProjectId, chains }),
    walletConnectWallet({
      projectId: walletConnectProjectId,
      chains,
      options: {
        projectId: walletConnectProjectId,
        showQrModal: false,
        qrModalOptions: {
          explorerRecommendedWalletIds: [
            "0b415a746fb9ee99cce155c2ceca0c6f6061b1dbca2d722b3ba16381d0562150",
            "1aedbcfc1f31aade56ca34c38b0a1607b41cccfa3de93c946ef3b4ba2dfab11c",
          ],
        },
      },
    }),
    coinbaseWallet({ appName: "DYNA", chains }),
    rabbyWallet({ chains, shimDisconnect: true }),
    okxWallet({ projectId: walletConnectProjectId, chains }),
    ...(needsInjectedWalletFallback
      ? [injectedWallet({ chains, shimDisconnect: true })]
      : []),
  ],
}])

export const wagmiConfig = createConfig({
  autoConnect: true,
  connectors,
  publicClient,
})

export const chain = chains
